<template>
  <section
    class="hero section center-content"
    :class="[
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]"
  >
    <div class="container-sm">
      <div
        class="hero-inner section-inner"
        :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]"
      >
        <div class="hero-content">
          <h1
            class="mt-0 mb-16 reveal-from-top"
            data-reveal-delay="300"
          >The #1 Customer Retention Tool For Subscription Businesses</h1>
          <div class="container-xs">
            <p class="mt-0 mb-32 reveal-from-top" data-reveal-delay="400">
              Customizable off-boarding flows help you retain more subscribers, and learn
              <em>why</em> your paying customers are leaving.
            </p>
            <div class="reveal-from-top" data-reveal-delay="500">
              <c-button
                tag="a"
                color="primary"
                href="#"
                @click.prevent="$emit('openSignupModal')"
                wide-mobile
              >Learn Your Churn</c-button>
            </div>
          </div>
        </div>
        <div class="hero-figure illustration-element-01 reveal-from-top" data-reveal-delay="500">
          <img
            class="has-shadow"
            :src="require('@/assets/images/hero-media.png')"
            width="896"
            height="504"
            alt="Hero"
          />
          <div style="position:absolute;left:-5.9%;right:5.9%;top:-12.74%;">
            <img
              :src="require('@/assets/images/hero-image-top.png')"
              width="896"
              height="504"
              alt="Hero top"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import CButton from "@/components/elements/Button.vue";

export default {
  name: "CHeroFull",
  mixins: [SectionProps],
  components: {
    CButton
  }
};
</script>